import { render, staticRenderFns } from "./TakeLeaveParent.vue?vue&type=template&id=4824703a&scoped=true"
import script from "./TakeLeaveParent.vue?vue&type=script&lang=js"
export * from "./TakeLeaveParent.vue?vue&type=script&lang=js"
import style0 from "./TakeLeaveParent.vue?vue&type=style&index=0&id=4824703a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4824703a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4824703a')) {
      api.createRecord('4824703a', component.options)
    } else {
      api.reload('4824703a', component.options)
    }
    module.hot.accept("./TakeLeaveParent.vue?vue&type=template&id=4824703a&scoped=true", function () {
      api.rerender('4824703a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parentdiary/TakeLeaveParent.vue"
export default component.exports